import {ConnectedSignInWidget} from '@eCommerce/frontend-legacy-shared-library-native';
import {
  CommonActions,
  useLinkTo,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import {RouteProp} from '@react-navigation/native';
import {View} from 'native-base';
import React from 'react';
import {Platform, TouchableOpacity} from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';

import {SafeAreaViewCentered} from 'components/Views';
import {Routes} from 'models/Navigation';
import {useTheme} from 'styled-components/native';

type ParamList = {
  Signin: {forwardUrl: string; enableLoadingScreen: boolean; msg: string};
};

const SigninScreen: React.FunctionComponent = () => {
  const navigation = useNavigation();
  const os = Platform.OS;
  const route = useRoute<RouteProp<ParamList, 'Signin'>>();
  const linkTo = useLinkTo();
  const theme = useTheme();
  const {ghostWhite, tuna} = theme.colors;

  const resetStack = () => {
    const resetAction = CommonActions.reset({
      index: 0,
      routes: [{name: Routes.Main.StackName}],
    });
    navigation.dispatch(resetAction);
  };
  const content = (
    <>
      <ConnectedSignInWidget
        forwardUrl={route.params?.forwardUrl}
        showLoadingScreen={route.params?.enableLoadingScreen}
      />

      <View
        position="absolute"
        mr={4}
        mt={4}
        zIndex={999}
        top="0"
        right={os !== 'web' ? '2' : '0'}
        alignSelf="flex-end">
        <TouchableOpacity
          testID="go-back-button"
          onPress={() => {
            if (route.params?.msg === 'timeout') {
              navigation.navigate(Routes.Main.Home);
            } else if (navigation.canGoBack()) {
              navigation.goBack();
            } else if (route.params?.forwardUrl) {
              const url = route.params?.forwardUrl;
              resetStack();
              setTimeout(() => {
                try {
                  linkTo(url);
                } catch {
                  resetStack();
                }
              }, 0);
            } else {
              resetStack();
            }
          }}>
          <Icon name="times" size={theme.fontSizes[8]} color={tuna} light />
        </TouchableOpacity>
      </View>
    </>
  );

  return (
    <SafeAreaViewCentered style={{backgroundColor: ghostWhite}}>
      {os !== 'web' ? <View width="100%">{content}</View> : <>{content}</>}
    </SafeAreaViewCentered>
  );
};

export default SigninScreen;
